import React from 'react';
import {
  widgetDefaultProps,
  widgetPropType,
  getStringsForWidget,
  getMarkdownStringsForWidget,
} from '@glowforge/gf-styled/models/widget';

import ReferralModal from './referral-modal-rebrand';

const ReferralModalWidget = (props) => {
  const { background, images, sections } = props;

  const strings = getStringsForWidget(props);
  const markdownStrings = getMarkdownStringsForWidget(props);

  const backgroundPattern = background?.fields?.desktopImage?.fields?.file?.url;

  const backgroundImage = images[0];

  const cta =
    sections?.find(
      (section) => section.fields.id === 'referral-modal-rebrand-cta'
    ) ?? null;

  return (
    <ReferralModal
      background={{
        backgroundImage,
        backgroundPattern,
      }}
      cta={cta}
      markdownStrings={markdownStrings}
      strings={strings}
    />
  );
};

ReferralModalWidget.propTypes = widgetPropType;
ReferralModalWidget.defaultProps = widgetDefaultProps;

export default ReferralModalWidget;
